import { Role, type UserDTO } from '@/services/api/user/types'

export function serializeUser(user: UserDTO): UserDTO {
  // Only these fixed, small identity fields are persisted in the auth cookie.
  // The API can return additional fields (e.g. `permissions`, `profiles`, `region`,
  // `wallet_balance`) that are large enough to push the cookie past the ~4KB
  // browser limit, which makes the browser silently refuse to set it at all.
  const {
    id,
    full_name,
    phone,
    email,
    email_verified_at,
    profile,
    receive_promotional_notifications,
    receive_system_notifications,
    created_at,
  } = user

  return {
    id,
    full_name,
    phone,
    email,
    email_verified_at,
    profile,
    receive_promotional_notifications,
    receive_system_notifications,
    created_at,
  }
}

export function getRedirectRoute(user: UserDTO) {
  const { profile } = user;
  return '/dashboard';
}
